import { channels, subChannels } from './Channels'
import { InvoiceTypeFormat } from './EnumEntity';
import { utils } from '../utils/utils';

export const title = 'Listado de Facturas'

export const columns = [
    {
        field: 'voucher',
        header: 'Canal',
        translate: (voucher) => `${channels.labels[voucher.source]} | ${subChannels.labels[voucher.subchannel]}`
    },
    {
        field: 'type',
        header: 'Tipo',
        translate: (type) => InvoiceTypeFormat[type],
        sizes: { xs: 1 }
    },
    {
        field: 'invoice',
        header: 'Cod. comprobante',
        translate: (invoice) => `${utils.zeroPad(invoice.billingCode, 5)}-${utils.zeroPad(invoice.number, 8)}`,
    },
    {
        field: 'seller',
        header: 'Vendedor',
        translate: (seller) => seller.code,
        tooltip: (invoice) => invoice.seller.userName,
        sizes: { xs: 1 }
    },
    {
        field: 'customer',
        header: 'Cliente',
        translate: (customer) => customer?.lastName
            ? `${customer?.firstName} ${customer?.lastName}`
            : customer?.firstName,
    },
    {
        field: 'amount',
        header: 'Importe',
        type: 'money',
        sizes: { xs: 1 }
    },
    {
        field: 'created',
        header: 'Creado',
        type: 'date',
        sizes: { xs: 2 }
    },
    {
        field: 'isFromApp',
        header: 'Iniciada en la App?',
        type: 'boolean',
        sizes: { xs: 1 }
    }
]